import { usePrefs } from './prefs.js'

/**
 * The radar loading animation (Creative, public/loading-radar.svg): the boot splash (index.html) and
 * the map while it loads (bugs.md). SFW mode gets the scope and sweep without the blip; a device that
 * asks for reduced motion gets the still logo, fading in and out (map.css). index.html makes the same
 * choice before any script.
 */
export function loaderSrc(): string {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return '/logo.svg'
  return usePrefs.getState().sfw ? '/loading-radar-sfw.svg' : '/loading-radar.svg'
}

/** The boot splash gives way once the app has painted (it fades; then it's gone). */
export function endBootSplash() {
  const el = document.getElementById('fm-boot')
  if (!el) return
  el.classList.add('fm-boot--done')
  window.setTimeout(() => el.remove(), 400)
}
